export enum enFilter {
    hour = 'hour',
    yearly = 'yearly',
    year = 'year',
    week = 'week',
    today = 'today',
    last24hours = 'last 24 hours',
    last30min = 'last 30 mins',
    last15min = 'last 15 mins',
    last30days = 'last 30 days',
    last90days = 'last 90 days',
    monthly = 'monthly',
    selectFilter = 'Select Filter',
    last20mins = 'last 20 mins'
}

export enum enPdf {
    print = 'Print',
    Pdf = 'Pdf'
}

export enum route {
    stat = 'https://app.zainergy.com/backend/zainergy/custom/directory/zainergy?action=getLatestStatsByDevice'
}

export enum exceptForLoader {
    kpi = 'getLatestStatsByDevice',
    analysisKpi = 'getDeviceAnalysisKPI',
    levelKpi = 'getDeviceLevelKPI',
    counterCorrection = 'getCounterCorrection'
}

export enum endeviceType {
    voltage = 'Meter',
    temp_hum = 'Sensor'
}

export interface ParameterConfig {
    key?: string;      // Key used for mapping
    params: string;    // Display name
    unit: string;
    min?: number;
    minDate?: string;
    max?: number;
    maxDate?: string;
}

export const PARAMETER_CONFIGS: ParameterConfig[] = [
    { key: 'val_vl_rn', params: 'Phase Voltage V1-N', unit: 'Volt' },
    { key: 'val_vl_yn', params: 'Phase Voltage V2-N', unit: 'Volt' },
    { key: 'val_vl_bn', params: 'Phase Voltage V3-N', unit: 'Volt' },
    { key: 'val_vl_ry', params: 'Line Voltage V-12', unit: 'Volt' },
    { key: 'val_vl_yb', params: 'Line Voltage V-23', unit: 'Volt' },
    { key: 'val_vl_br', params: 'Line Voltage V-31', unit: 'Volt' },
    { key: 'val_avg_vl_pp', params: 'AVG Phase Voltage VL-L', unit: 'Volt' },
    { key: 'val_curr_r', params: 'Line Current L1', unit: 'Ampere' },
    { key: 'val_curr_y', params: 'Line Current L2', unit: 'Ampere' },
    { key: 'val_curr_b', params: 'Line Current L3', unit: 'Ampere' },
    { key: 'val_avg_curr_3p', params: 'Avg. 3 Phase Current', unit: 'Ampere' },
    { key: 'val_avg_pf_3p', params: 'Power Factor 3 Phase (Avg)', unit: '-' },
    { key: 'val_frequency', params: 'Frequency', unit: 'Hz' },
    { key: 'val_w_r', params: 'Active Power L1', unit: 'KW' },
    { key: 'val_w_y', params: 'Active Power L2', unit: 'KW' },
    { key: 'val_w_b', params: 'Active Power L3', unit: 'KW' },
    { key: 'val_total_w', params: 'Total Active Power', unit: 'KW' },
    { key: 'val_total_va', params: 'Total Apparent Power', unit: 'KVA' },
    { key: 'val_total_var', params: 'Total Reactive Power', unit: 'KVAR' },
];


